import React from 'react';

import { fg } from '@townsquare/stat-sig/gate';

export type CollaborationContext = {
	goalWorkspace: string | null;
	projectWorkspace: string | null;
	rovoWorkspace: string | null;
	contextId?: string | null;
	orgCloudIds: string[] | null;
	numWorkspaces?: number;
	collabContextScoping?: {
		collabContextCloudIds?: string[];
		isMultiSite?: boolean;
		collabContextSiteAris?: string[];
		hasMultipleUnits?: boolean;
	} | null;
};

export const CollabContext: React.Context<CollaborationContext | null> =
	React.createContext<CollaborationContext | null>(null);

export const useCollabContext = (): CollaborationContext | null => {
	return React.useContext(CollabContext);
};

export const useRovoWorkspace = (): string | null | undefined => {
	const context = useCollabContext();
	return context?.rovoWorkspace;
};

export const useGoalWorkspace = (): string | null => {
	const context = useCollabContext();
	return context?.goalWorkspace ?? null;
};

export const useProjectWorkspace = (): string | null => {
	const context = useCollabContext();
	return context?.projectWorkspace ?? null;
};

export const useContextId = (): string | null => {
	const context = useCollabContext();
	return context?.contextId ?? null;
};

export const useCollabContextCloudIds = (): string[] => {
	const context = useCollabContext();

	return context?.collabContextScoping?.collabContextCloudIds ?? context?.orgCloudIds ?? [];
};

/**
 * cc-units-eap is a global gate used to synchronise the EAP customers
 * townsquare-enable-units is our killswitch. We'll set this to 100% by default and leave the rollout to the Units team.
 */
export const useUnitsEnabled = (): boolean => {
	return fg('cc-units-eap') && fg('townsquare_enable_units');
};
